/**
 * @generated SignedSource<<d92499205700f64ec5cef4bfcc763096>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MediaEditorThumb_media$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"MediaThumb_media">;
  readonly " $fragmentType": "MediaEditorThumb_media";
};
export type MediaEditorThumb_media$key = {
  readonly " $data"?: MediaEditorThumb_media$data;
  readonly " $fragmentSpreads": FragmentRefs<"MediaEditorThumb_media">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MediaEditorThumb_media",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MediaThumb_media"
    }
  ],
  "type": "Media",
  "abstractKey": null
};

(node as any).hash = "ff94ec8adbf9c7b799483dc3e8623630";

export default node;
